import VariablesCreate from './VariablesCreate';

export default VariablesCreate;
